import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';
import { Operation } from '../../types';

export const INELIGIBLE_ACTION_TYPES_FOR_ADDING: ActionType[] = [
  ActionType.INPUT,
  ActionType.SERVICE,
  ActionType.IMPORTED_MATRIX_MODEL,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.OUTCOME_REASON,
];

export const INELIGIBLE_ACTION_TYPES_FOR_REMOVING: ActionType[] = [
  ActionType.SERVICE,
];


export const INELIGIBILITY_MAP = {
  [Operation.Add]: INELIGIBLE_ACTION_TYPES_FOR_ADDING,
  [Operation.Remove]: INELIGIBLE_ACTION_TYPES_FOR_REMOVING,
};
